import React, { Fragment } from 'react'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import {
  TableRow,
  TableCell,
  Collapse,
  Typography
} from '@mui/material'
import { ExpandableConfig, TableData } from '../types'

interface ExpandableContentProps<T extends TableData> {
  expanded: boolean
  detailData: any
  row: T
  expandable: ExpandableConfig<T>
  colSpan: number
  rowId: string | number
}

export const ExpandableContent = <T extends TableData>({
  expanded,
  detailData,
  row,
  expandable,
  colSpan,
  rowId
}: ExpandableContentProps<T>) => {
  const styles = useStyles()

  return (
    <TableRow key={`expanded-${rowId}`}>
      <TableCell
        colSpan={colSpan}
        className={styles.collapseCell}
        style={{
          border: expanded ? '1px solid rgba(224, 224, 224, 1)' : 'none'
        }}
      >
        <Collapse in={expanded} timeout='auto' unmountOnExit>
          <div className={styles.expandedContent}>
            {detailData ? (
              <Fragment>
                {expandable.renderContent(detailData, row)}
              </Fragment>
            ) : (
              <Typography variant='body2' className={styles.noDetails}>
                No hay detalles disponibles
              </Typography>
            )}
          </div>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  collapseCell: {
    padding: 0,
    borderBottom: 'none'
  },
  expandedContent: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.grey[50],
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    '& > *:first-child': {
      marginTop: 0
    },
    '& > *:last-child': {
      marginBottom: 0
    }
  },
  noDetails: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic'
  }
}))